import { render } from "./numberSelection.vue?vue&type=template&id=1d7b21da&scoped=true"
import script from "./numberSelection.vue?vue&type=script&lang=js"
export * from "./numberSelection.vue?vue&type=script&lang=js"

import "./numberSelection.vue?vue&type=style&index=0&id=1d7b21da&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7b21da"]])

export default __exports__